var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgError(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.99935 15.3334C3.99477 15.3334 0.666016 12.0047 0.666016 8.00008C0.666016 3.98832 3.98758 0.666748 7.99216 0.666748C12.0039 0.666748 15.3327 3.98832 15.3327 8.00008C15.3327 12.0047 12.0111 15.3334 7.99935 15.3334ZM7.99935 14.1112C11.3928 14.1112 14.1105 11.3935 14.1105 8.00008C14.1105 4.60662 11.3856 1.88897 7.99216 1.88897C4.5987 1.88897 1.89543 4.60662 1.89543 8.00008C1.89543 11.3935 4.60588 14.1112 7.99935 14.1112Z",
    fill: "#FD5862"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.00177 9.03938C7.61726 9.03938 7.30257 8.73341 7.29176 8.34906L7.19281 4.83204C7.17999 4.37635 7.5459 4 8.00177 4C8.45763 4 8.82354 4.37635 8.81072 4.83204L8.71178 8.34906C8.70096 8.73341 8.38627 9.03938 8.00177 9.03938ZM8.00177 12C7.52155 12 7.13281 11.6383 7.13281 11.1758C7.13281 10.7179 7.52155 10.3562 8.00177 10.3562C8.4774 10.3562 8.86615 10.7179 8.86615 11.1758C8.86615 11.6383 8.4774 12 8.00177 12Z",
    fill: "#FD5862"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgError);
export default __webpack_public_path__ + "static/media/error.8e8f47acaa1d558bbe591f7556714621.svg";
export { ForwardRef as ReactComponent };